import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty'
import {
    fetchAndSwitchToImage, onAmplitudeOrScaleChange, onCloseImage, onDeleteImage, onImageLoadError,
    onToggleSelectImage
} from '../actions/ImageActions';
import {apiRoot} from '../Api';
import {nextIndex, prevIndex} from '../utils';
import {onImageViewerSelectionSetPreferred, onImageViewerSetPreferred, onImageViewerToggleOriginal} from '../actions/PresetActions';
import {hasOpenModal as hasOpenModalInternal} from '../reducers/modals';
import FileUploadContainer from './FileUploadContainer';
import {withRouter} from 'react-router-dom';
import Workspace from '../components/Workspace';
import {ENHANCEMENT, ORIGINAL, POPPED, SITE_NAME} from '../Constants';
import ContainerDimensions from 'react-container-dimensions';
import {openImageContextSelector} from '../reducers/openImageContextSelector';
import size from 'lodash/size'
import findIndex from 'lodash/findIndex'
import filter from 'lodash/filter';
import {Helmet} from 'react-helmet';
import {PAN, ZOOMIN, ZOOMOUT} from 'rc-canvas/lib/ZoomPanModes';
import {getFilteredAndSortedImages, getSortedSelectedImages} from '../reducers/imagesSelector';

@withRouter
@connect(state => ({
    openImageContext: openImageContextSelector(state),
    controlPanelSettings: state.controlPanel,
    hasOpenModal: () => hasOpenModalInternal(state.modals),
    images: getFilteredAndSortedImages(state),
    sortedSelectedImages: getSortedSelectedImages(state),
}), {
    fetchAndSwitchToImage,
    onImageLoadError,
    onToggleSelectImage,
    onDeleteImage,
    onImageViewerToggleOriginal,
    onImageViewerSetPreferred,
    onImageViewerSelectionSetPreferred,
    onAmplitudeOrScaleChange,
    onCloseImage,
})
export default class WorkspaceContainer extends Component {
    static propTypes = {
        galleryUrl: PropTypes.string,
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string
            }),
        }),
        openImageContext: PropTypes.shape({
            id: PropTypes.number,
            userId: PropTypes.any,
            imageInfo: PropTypes.object,
            images: PropTypes.object,
            userImages: PropTypes.object,
            users: PropTypes.object,
            spread: PropTypes.number,
            amplitude: PropTypes.number,
            openImage: PropTypes.shape({
                isOriginalActive: PropTypes.bool,
                activeImage: PropTypes.oneOf([ORIGINAL, POPPED, ENHANCEMENT]),
            }),
            imageEditHistory: PropTypes.object,
        }),
        fetchAndSwitchToImage: PropTypes.func,
        onImageLoadError: PropTypes.func,
        images: PropTypes.array,
        sortedSelectedImages: PropTypes.array,
        onToggleSelectImage: PropTypes.func,
        onDeleteImage: PropTypes.func,
        onImageViewerToggleOriginal: PropTypes.func,
        onImageViewerSetPreferred: PropTypes.func,
        onImageViewerSelectionSetPreferred: PropTypes.func,
        onAmplitudeOrScaleChange: PropTypes.func,
        hasOpenModal: PropTypes.func,
        isDemo: PropTypes.bool,
        location: PropTypes.object,
        controlPanelSettings: PropTypes.object,
        onCloseImage: PropTypes.func,
    };

    componentWillMount() {
        this.loadImage(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.loadImage(nextProps);
        }
    }

    componentWillUnmount() {
        console.log('Unmounting WorkspaceContainer');
    }

    loadImage = (props) => {
        const {match: {params: {id}}} = props;
        props.fetchAndSwitchToImage(parseInt(id, 10));
    };

    handleOpenFileUpload = () => {
        this.fileUpload.open();
    };

    isPreventKeyNavigation = () => {
        const {tool} = this.props.controlPanelSettings;
        return tool === PAN || tool === ZOOMIN || tool === ZOOMOUT;
    };

    render() {
        const {galleryUrl, openImageContext, images, sortedSelectedImages, isDemo, controlPanelSettings} = this.props;
        const {imageInfo, user, amplitude, spread, openImage, imageEditHistory} = openImageContext;
        const {isOriginalActive, activeImage} = openImage;
        if (isEmpty(imageInfo)) {
            return false;
        }

        let prevId, nextId, currIdx;
        let prefetchImages = [];
        if (!isEmpty(images)) {
            const count = size(images);
            currIdx = findIndex(images, ['id', imageInfo.id]);
            if (currIdx !== -1) {
                const nextIdx = nextIndex(currIdx, count);
                const prevIdx = prevIndex(currIdx, count);
                prevId = images[prevIdx].id;
                nextId = images[nextIdx].id;
                if (prevId === imageInfo.id) {
                    prevId = null;
                }
                if (nextId === imageInfo.id) {
                    nextId = null;
                }
                prefetchImages = filter([
                    images[nextIdx].origSrc,
                    images[nextIdx].poppedSrc,
                    images[prevIdx].origSrc,
                    images[prevIdx].poppedSrc,
                ]);
            }
        }

        return (
            <FileUploadContainer
                uploadContext="editor"
                multiple={false}
                disabled={isDemo}
                fileUploadRef={c => this.fileUpload = c}
            >
                <Helmet>
                    <title>{`${SITE_NAME} - ${isDemo ? 'Demo: ' : ''}${imageInfo.fileName}`}</title>
                    {
                        prefetchImages.map((imgSrc, idx) => {
                            return <link key={idx} rel="prefetch" href={imgSrc}/>
                        })
                    }
                </Helmet>
                <ContainerDimensions>{({width, height}) => (
                    <Workspace
                        srcPrefix={apiRoot}
                        galleryUrl={galleryUrl}
                        images={images}
                        imageInfo={imageInfo}
                        onImageLoadError={this.props.onImageLoadError}
                        selectedImages={sortedSelectedImages}
                        onSelect={this.props.onToggleSelectImage}
                        onDelete={this.props.onDeleteImage}
                        amplitude={amplitude}
                        spread={spread}
                        isOriginalActive={isOriginalActive}
                        activeImage={activeImage}
                        onImageViewerToggleOriginal={this.props.onImageViewerToggleOriginal}
                        onImageViewerSetPreferred={this.props.onImageViewerSetPreferred}
                        onImageViewerSelectionSetPreferred={this.props.onImageViewerSelectionSetPreferred}
                        onAmplitudeOrScaleChange={this.props.onAmplitudeOrScaleChange}
                        editHistory={imageEditHistory}
                        user={user}
                        hasOpenModal={this.props.hasOpenModal}
                        isDemo={isDemo}
                        controlPanelSettings={controlPanelSettings}
                        onOpenFileUpload={this.handleOpenFileUpload}
                        width={Math.round(width)}
                        height={Math.round(height)}
                        prevId={prevId}
                        nextId={nextId}
                        currIdx={currIdx}
                        preventKeyNavigation={this.isPreventKeyNavigation()}
                        onCloseImage={this.props.onCloseImage}
                    />
                )}</ContainerDimensions>
            </FileUploadContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/WorkspaceContainer.js